/**
 * Mr. X reveal helpers.
 *
 * Source: docs/rules.md "Mr. X reveals" — Mr. X must reveal his current
 * station after his move on rounds 3, 8, 13, 18, and 24.
 */

import type { LogTransport, MrxLogEntry } from '../types'
import { REVEAL_ROUNDS } from './constants'

/** True if a Mr. X move on this round number must reveal his station. */
export function isRevealRound(round: number): boolean {
  return REVEAL_ROUNDS.has(round)
}

/**
 * Build a Mr. X log entry, attaching the current station only on reveal
 * rounds. `mrxStation` must be Mr. X's *post-move* station.
 */
export function buildLogEntry(args: {
  round: number
  transport: LogTransport
  mrxStation: number
  doubleMoveSecond: boolean
}): MrxLogEntry {
  const { round, transport, mrxStation, doubleMoveSecond } = args
  return {
    round,
    transport,
    revealedStation: isRevealRound(round) ? mrxStation : null,
    doubleMoveSecond,
  }
}

/**
 * Convenience: given an existing log entry without reveal info, attach the
 * station number iff this round's a reveal round. Returns a new entry.
 */
export function applyRevealIfNeeded(
  entry: MrxLogEntry,
  mrxStation: number,
): MrxLogEntry {
  if (!isRevealRound(entry.round)) return entry
  return { ...entry, revealedStation: mrxStation }
}
